import React from 'react';
import { View, StyleSheet, ScrollView, useWindowDimensions } from 'react-native';
import ZenSkeleton from '../../shared/commonComponents/zenSkeleton';
import { appColors } from 'zen-core-elements/src/shared/constants';

const DashboardSkeleton = () => {
    const { width, height } = useWindowDimensions();
    const isLandscape = width > height;

    return (
        <View style={styles.container}>
            {/* Header Skeleton */}
            {/* <View style={styles.header}>
                <View>
                    <ZenSkeleton width={150} height={24} borderRadius={4} />
                    <ZenSkeleton width={100} height={16} borderRadius={4} style={{ marginTop: 8 }} />
                </View>
                <ZenSkeleton width={120} height={40} borderRadius={20} />
            </View> */}

            <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={styles.content}>

                {/* Metrics Row Skeleton */}
                <View style={styles.metricsRow}>
                    {[1, 2, 3, 4].map((item) => (
                        <View key={item} style={styles.metricCardItem}>
                            <View style={styles.card}>
                                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                    <ZenSkeleton width={48} height={48} borderRadius={24} style={{ marginRight: 15 }} />
                                    <View>
                                        <ZenSkeleton width={80} height={16} borderRadius={4} />
                                        <ZenSkeleton width={60} height={14} borderRadius={4} style={{ marginTop: 6 }} />
                                    </View>
                                </View>
                            </View>
                        </View>
                    ))}
                </View>

                {/* Split Section Skeleton */}
                <View style={[styles.splitSection, { flexDirection: isLandscape ? 'row' : 'column' }]}>

                    {/* Left: Chart Skeleton */}
                    <View style={[styles.card, { flex: isLandscape ? 0.65 : 1, height: 350, alignItems: 'center', justifyContent: 'center' }]}>
                        <View style={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 20 }}>
                            <ZenSkeleton width={150} height={20} />
                            <ZenSkeleton width={80} height={20} />
                        </View>
                        <ZenSkeleton width={200} height={200} borderRadius={100} />
                        <View style={{ flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', marginTop: 20, gap: 10 }}>
                            {[1, 2, 3, 4].map(i => (
                                <ZenSkeleton key={i} width={80} height={16} borderRadius={4} />
                            ))}
                        </View>
                    </View>

                    {/* Right: Lists Skeleton */}
                    <View style={{ flex: isLandscape ? 0.35 : 1, marginLeft: isLandscape ? 15 : 0, marginTop: isLandscape ? 0 : 20 }}>
                        {[1, 2].map((cardIndex) => (
                            <View key={cardIndex} style={[styles.card, { marginBottom: 15 }]}>
                                <ZenSkeleton width={120} height={20} style={{ marginBottom: 15 }} />
                                {[1, 2].map((item) => (
                                    <View key={item} style={{ marginBottom: 12 }}>
                                        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                                <ZenSkeleton width={32} height={32} borderRadius={8} style={{ marginRight: 12 }} />
                                                <ZenSkeleton width={80} height={16} />
                                            </View>
                                            <ZenSkeleton width={40} height={16} />
                                        </View>
                                        {item !== 2 && <View style={{ height: 1, backgroundColor: '#f0f0f0', marginVertical: 8 }} />}
                                    </View>
                                ))}
                            </View>
                        ))}
                    </View>
                </View>
                {/* Gift Card Report Skeleton */}
                {/* <View style={[styles.card, { marginBottom: 15 }]}>
                    <ZenSkeleton width={120} height={20} style={{ marginBottom: 15 }} />
                    {[1, 2].map((item) => (
                        <View key={item} style={{ marginBottom: 12 }}>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                    <ZenSkeleton width={32} height={32} borderRadius={8} style={{ marginRight: 12 }} />
                                    <ZenSkeleton width={80} height={16} />
                                </View>
                                <ZenSkeleton width={40} height={16} />
                            </View>
                            {item !== 2 && <View style={{ height: 1, backgroundColor: '#f0f0f0', marginVertical: 8 }} />}
                        </View>
                    ))}
                </View> */}

                {/* Progress Section Skeleton */}
                <View style={styles.progressSection}>
                    <View style={{ flexDirection: 'row', justifyContent: 'space-around' }}>
                        {[1, 2, 3, 4].map((item) => (
                            <View key={item} style={{ alignItems: 'center' }}>
                                <ZenSkeleton width={50} height={50} borderRadius={25} />
                                <ZenSkeleton width={60} height={12} style={{ marginTop: 8 }} />
                            </View>
                        ))}
                    </View>
                </View>

            </ScrollView>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: appColors.lightBackgroundColor,
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 15,
        backgroundColor: appColors.light,
        marginBottom: 10
    },
    content: {
        padding: 15
    },
    metricsRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        marginBottom: 10,
    },
    metricCardItem: {
        width: '23.5%',
        minWidth: 160,
        marginBottom: 10
    },
    card: {
        backgroundColor: appColors.light,
        borderRadius: 20,
        padding: 15,
        elevation: 2,
    },
    splitSection: {
        justifyContent: 'space-between',
    },
    progressSection: {
        marginTop: 20,
        padding: 20,
        backgroundColor: appColors.light,
        borderRadius: 20,
    }
});

export default DashboardSkeleton;
